import React from 'react';
import {Text, TextButton} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './SummaryTitle.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {BiMobilePosition} from '../../../../domain/utils/bi.util';
import {A11yIds, SPECS} from '../../../../common/constants';
import {useExperiments} from '@wix/yoshi-flow-editor';

export enum SummaryTitleDataHooks {
  root = 'SummaryTitleDataHooks.root',
  titleText = 'SummaryTitleDataHooks.title',
  editCartButton = 'SummaryTitleDataHooks.editCartButton',
  numberOfOrders = 'SummaryTitleDataHooks.numberOfOrders',
}
export interface SummaryTitleProps {
  shouldShowNumberOfItems?: boolean;
}
export const SummaryTitle = ({shouldShowNumberOfItems}: SummaryTitleProps) => {
  const localeKeys = useLocaleKeys();
  const {
    navigationStore: {editCartUrl, clickOnEditCart, isDonationsTheme},
    checkoutStore: {cart},
    checkoutSettingsStore: {checkoutContent},
    isOneColumnView,
  } = useControllerProps();
  const {experiments} = useExperiments();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  const summaryTitleText = isDonationsTheme
    ? localeKeys.checkout.donations.donation_summary()
    : localeKeys.checkout.order_summary.$value();
  const summaryTitleTextWithOverride = checkoutContent?.orderSummary ?? summaryTitleText;

  const numberOfItemsText = checkoutUIRevampOrderSummary
    ? localeKeys.checkout.order_summary.numberOfItems({
        numberOfItems: cart.numberOfItems,
      })
    : `(${cart.numberOfItems})`;
  const handleEditCartClick = () => {
    clickOnEditCart(isOneColumnView ? BiMobilePosition.top : undefined);
  };

  return (
    <div data-hook={SummaryTitleDataHooks.root} className={classes.title} id={A11yIds.SummarySection}>
      <div className={classes.header}>
        <Text tagName={'h2'} className={classes.titleText} data-hook={SummaryTitleDataHooks.titleText}>
          {summaryTitleTextWithOverride}
        </Text>{' '}
        {shouldShowNumberOfItems && (
          <Text
            data-hook={SummaryTitleDataHooks.numberOfOrders}
            className={classes.numberOfOrders}
            aria-label={localeKeys.checkout.orderSummary.itemAmount_ariaLabel({
              itemNumber: cart.numberOfItems,
            })}>
            {numberOfItemsText}
          </Text>
        )}
      </div>
      {cart.currentCart && (
        <div className={classes.editCartButtonWrapper}>
          <TextButton
            as={'a'}
            href={editCartUrl}
            onClick={handleEditCartClick}
            className={classes.editCartButton}
            data-hook={SummaryTitleDataHooks.editCartButton}>
            {localeKeys.checkout.edit_cart()}
          </TextButton>
        </div>
      )}
    </div>
  );
};
